import { Config } from '../Config';
import axios from "axios"
import Fnc from './Functions';

let jsonpAdapter = require('axios-jsonp');

var basketValidation = (callback) => {
    getRecaptchaToken("basketValidation", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/basket',
            headers: { 
                'Template' : calculateOrigin() 
            },
            params: {
                token: token,
                validation: "true"
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API BASKET VALIDATION", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var basketDelAll = (callback) => {
    getRecaptchaToken("basketDelAll", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'delete',
            url: Fnc.currEnv().apiPath + '/basket/all',
            headers: { 
                'Template' : calculateOrigin() 
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API BASKET DEL ALL", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var basketDelItem = (id, callback) => {
    getRecaptchaToken("basketDelItem", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'delete',
            url: Fnc.currEnv().apiPath + '/basket/' + id,
            headers: { 
                'Template' : calculateOrigin() 
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API BASKET DEL ITEM", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var sendCoupon = (coupon, callback) => {
    getRecaptchaToken("sendCoupon", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'put',
            url: Fnc.currEnv().apiPath + '/basket/coupon',
            headers: { 
                'Template' : calculateOrigin() 
            },
            params: {
                token: token,
                coupon: coupon
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API SEND COUPON", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};
var getUser = (callback) => {
    getRecaptchaToken("getUser", (token) => {
        axios.defaults.withCredentials = true;
        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/user',
            headers: { 
                'Content-Type': 'application/json',
                'Template' : calculateOrigin() 
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API GET USER", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var getCustomer = (piva, callback) => {
    getRecaptchaToken("getCustomer", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/customer',
            headers: { 
                'Content-Type': 'application/json',
                'Template' : calculateOrigin() 
            },
            params: {
                token: token,
                piva: piva
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API GET CUSTOMER", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var verifyEmail = (email, callback) => {
    getRecaptchaToken("verifyEmail", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/email',
            headers: { 
                'Content-Type': 'application/json',
                'Template' : calculateOrigin() 
            },
            params: {
                token: token,
                email: email
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API VERIFY EMAIL", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var addItem = (data, callback) => {
    getRecaptchaToken("addItem", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'post',
            url: Fnc.currEnv().apiPath + '/basket',
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            },
            data: data
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API BASKET ADD ITEM", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};


//https://services.tuttocitta.it/lbs?st=it%2Cch&lg=ita&sito=ac_api&opentipo=0&nresout=6&nresac=50&dv=VIAREGGIO%20(LUCCA)&callback=iolpg_register_fillSuggCity&
var lbs = (val, opentipo, callback) => {

    axios.defaults.withCredentials = true;

    axios({
        method: 'get',
        url: Fnc.currEnv().apiLbsPath,
        headers: { 
            'Content-Type': 'application/json',
            'Template' : calculateOrigin() 
        },
        adapter: jsonpAdapter,
        params: {
            st: "it%2Cch",
            lg: "ita",
            sito: "ac_api",
            opentipo: opentipo,
            nresout: 6,
            nresac: 50,
            dv: val
        }
    })
    .then(function (response) {
        callback(response.data);
    })
    .catch(function (error) {
        Fnc.log("API LBS", error, Fnc.LogLvl.ERROR);
        callback(null);
    });

};

var zuoraIfrSignature = (pageId, callback) => {
    getRecaptchaToken("zuoraIfrSignature", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/checkout/signature',
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token,
                pageId: pageId
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA IFRAME SIGNATURE", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var billingPreview = (callback) => {
    getRecaptchaToken("billingPreview", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/basket:preview',
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA BILLING PREVIEW", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var getOrder = (id, callback) => {
    getRecaptchaToken("getOrder", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/order/' + id,
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA GET ORDER", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var addValue = (name, val, callback) => {

    var obj = {};
    obj["name"] = name;
    obj["value"] = val;

    getRecaptchaToken("addValue", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'post',
            url: Fnc.currEnv().apiPath + '/cookie:add',
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            },
            data: obj
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA ADD VALUE", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var cookieTest = (val, callback) => {

     getRecaptchaToken("cookieTest", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'post',
            headers: {
                'Content-Type': 'plain/text',
                'Template' : calculateOrigin()
            },
            url: Fnc.currEnv().apiPath + '/cookie',
            params: {
                token: token
            },
            data: val
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA COOKIE TEST", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};


var getPaymentMethods = (callback) => {

    getRecaptchaToken("getPaymentMethods", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/checkout/payment',
            headers: {
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ZUORA GET PAY METHODS", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};


var checkoutDirect = (fpt,refId, callback) => {

    getRecaptchaToken("checkoutDirect", (token) => {
       axios.defaults.withCredentials = true;

       axios({
           method: 'get',
           headers: {
               'Content-Type': 'plain/text',
               'Template' : calculateOrigin()
           },
           url: Fnc.currEnv().apiPath + '/checkout/direct',
           params: {
               token: token,
               refId: refId,
               field_passthrough1: fpt
           }
       })
       .then(function (response) {
           callback(response.data);
       })
       .catch(function (error) {
           Fnc.log("API CHECKOUT DIRECT", error, Fnc.LogLvl.ERROR);
           callback(null);
       });

   })
};

var getAllProducts = (callback) => {

    getRecaptchaToken("getAllProducts", (token) => {
       axios.defaults.withCredentials = true;

       axios({
           method: 'get',
           headers: {
               'Content-Type': 'plain/text',
               'Template' : calculateOrigin()
           },
           url: Fnc.currEnv().apiPath + '/products.json',
           params: {
              
           }
       })
       .then(function (response) {
           callback(response.data);
       })
       .catch(function (error) {
           Fnc.log("API GET PRODUCTS", error, Fnc.LogLvl.ERROR);
           callback(null);
       });

   })
};


var checkDomain = (domain,callback) => {

    getRecaptchaToken("checkDomain", (token) => {
       axios.defaults.withCredentials = true;

       axios({
           method: 'get',
           headers: {
               'Content-Type': 'plain/text',
               'Template' : calculateOrigin()
           },
           url: Fnc.currEnv().apiPath + '/domain',
           params: {
               token: token,
               domain: domain
           }
       })
       .then(function (response) {
           callback(response.data);
       })
       .catch(function (error) {
           Fnc.log("API CHECK DOMAIN", error, Fnc.LogLvl.ERROR);
           callback(null);
       });

   })
};

var updateBasket = (basket, callback) => {

    getRecaptchaToken("addDomain", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'put',
            url: Fnc.currEnv().apiPath + '/basket',
            headers: { 
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            },
            data: basket
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API ADD DOMAIN", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var sendBskRmrk = (phone, name, surname, ragSoc, piva, fProm, callback) => {
    getRecaptchaToken("sendBskRmrk", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'put',
            url: Fnc.currEnv().apiPath + '/basket/rmrk',
            headers: { 
                'Template' : calculateOrigin() 
            },
            params: {
                token: token,
                phone: phone,
                name: name,
                surname: surname,
                ragSoc: ragSoc,
                piva: piva,
                ct: fProm
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API SEND PHONE", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var logException = (cat, funct, desc, callback) => {

    getRecaptchaToken("logfexception", (token) => {
        axios.defaults.withCredentials = true;

        let payLd = {};
        payLd.cat = cat;
        payLd.function = funct;
        payLd.desc =desc;
        payLd.ua = window.navigator ? window.navigator.userAgent :  "";
        payLd.sessionId = Fnc.getSessionId(); 

        axios({
            method: 'post',
            url: Fnc.currEnv().apiPath + '/logfexception',
            headers: { 
                'Template' : calculateOrigin()
            },
            params: {
                token: token
            },
            data: payLd
        })
        .then(function (response) {
            if (callback) callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API LOG EXCEPTION", error, Fnc.LogLvl.ERROR);
            if (callback) callback(null);
        });

    })
};

var getPaypalToken = (callback) => {

    getRecaptchaToken("getPaypalToken", (token) => {
        axios.defaults.withCredentials = true;

        axios({
            method: 'get',
            url: Fnc.currEnv().apiPath + '/paypal/token',
            params: {
                token: token
            }
        })
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            Fnc.log("API GET PAYPAL TOKEN", error, Fnc.LogLvl.ERROR);
            callback(null);
        });

    })
};

var getRecaptchaToken = (apiName, callback) => {
    let tknBypass = Fnc.currEnv().bypassCaptchaToken;
    if (tknBypass && tknBypass.length > 0) {
        callback(tknBypass);
    } else {
        if (window.grecaptcha) {
            Fnc.log("Recaptcha loaded", window.grecaptcha, Fnc.LogLvl.ERROR);
            window.grecaptcha.ready(function () {
                Fnc.log("Recaptcha ready reached", window.grecaptcha, Fnc.LogLvl.INFO);
                window.grecaptcha.execute(Config.reCaptchaKey, { action: apiName }).then(function (token) {
                    // Add your logic to submit to your backend server here.
                    Fnc.log("Recaptcha executed", apiName, Fnc.LogLvl.INFO);
                    callback(token);
                });
            });
        } else {
            Fnc.log("Recaptcha not loaded", window.grecaptcha, Fnc.LogLvl.ERROR);
        }
    }
};


var calculateOrigin = () => {
    return window.location.href;
  }

export default { lbs, basketValidation, cookieTest, basketDelAll, basketDelItem, getUser, getCustomer, verifyEmail, addItem, sendCoupon, zuoraIfrSignature, billingPreview, getOrder, addValue, getPaymentMethods, checkoutDirect, getAllProducts, checkDomain, updateBasket, getPaypalToken, logException, sendBskRmrk }